declare global {
	interface Window {
		Cypress: Record<string, unknown>;
	}
}

export const useIsCypress = (): boolean => !!window.Cypress;
